import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { VisitorModifyRequest } from "./VisitorModifyRequest";

@Injectable()
export class DataService_MultiStationModifyVisitors {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	GetPhotoByPerson(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/GetPhotoByPerson?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorInsert(parms: VisitorModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorInsert?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorUpdate(parms: VisitorModifyRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorUpdate?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorModifyListInfoSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorModifyListInfoSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisitorEditInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisitorEditInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
